import { useLanguage } from "../context/LanguageContext";
import { Leaf, Users, Sparkles } from "lucide-react";

const icons = [Leaf, Users, Sparkles];

const Mission = () => {
  const { t } = useLanguage();

  return (
    <section
      id="mission"
      data-testid="mission-section"
      className="relative py-24 md:py-32 bg-[var(--bg-subtle)]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl mb-16 md:mb-24">
          <div className="text-xs uppercase tracking-[0.25em] text-[var(--brand-gold)] mb-4">
            {t.mission.eyebrow}
          </div>
          <h2 className="font-display text-[42px] md:text-[64px] leading-[1.05] text-[var(--text-primary)]">
            {t.mission.title}
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8">
          {t.mission.goals.map((goal, i) => {
            const Icon = icons[i];
            return (
              <div
                key={i}
                data-testid={`mission-card-${i}`}
                className="relative bg-[var(--bg-base)] rounded-3xl p-8 md:p-10 border border-white"
              >
                <div className="mb-8 inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-[var(--brand-gold-light)]/40 border border-[var(--brand-gold)]/30">
                  <Icon className="w-6 h-6 text-[var(--brand-gold)]" strokeWidth={1.5} />
                </div>
                <div className="font-display text-3xl text-[var(--text-primary)] mb-1">
                  0{i + 1}
                </div>
                <h3 className="font-display text-xl md:text-2xl text-[var(--text-primary)] mt-3 mb-3">
                  {goal.title}
                </h3>
                <p className="text-sm md:text-base text-[var(--text-secondary)] leading-relaxed">
                  {goal.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Mission;
